import { Button } from 'shared/components/ui';
import React from 'react';
import './FiltrosPagosFacturas.css';

const MESES = [
  { valor: 1, nombre: 'Enero' },
  { valor: 2, nombre: 'Febrero' },
  { valor: 3, nombre: 'Marzo' },
  { valor: 4, nombre: 'Abril' },
  { valor: 5, nombre: 'Mayo' },
  { valor: 6, nombre: 'Junio' },
  { valor: 7, nombre: 'Julio' },
  { valor: 8, nombre: 'Agosto' },
  { valor: 9, nombre: 'Septiembre' },
  { valor: 10, nombre: 'Octubre' },
  { valor: 11, nombre: 'Noviembre' },
  { valor: 12, nombre: 'Diciembre' },
];

const anioActual = new Date().getFullYear();
const ANIOS = [anioActual - 2, anioActual - 1, anioActual];

const ESTADOS_PAGO = [
  { valor: '', label: 'Todas' },
  { valor: 'IMPAGA', label: 'IMPAGA' },
  { valor: 'ABONADA', label: 'ABONADA' },
];

const FiltrosPagosFacturas = ({ filtros, onCambiarFiltros, onBuscar, entidades, obrasSociales }) => {
  const handleChange = (campo, valor) => {
    onCambiarFiltros({ ...filtros, [campo]: valor });
  };

  return (
    <div className="fpf-filtros">
      <div className="fpf-filtro">
        <label htmlFor="fpf-mes">Mes</label>
        <select
          id="fpf-mes"
          aria-label="Filtrar por mes"
          value={filtros.mes || ''}
          onChange={(e) => handleChange('mes', e.target.value ? parseInt(e.target.value) : '')}
          className="fpf-select"
        >
          <option value="">Todos</option>
          {MESES.map((m) => (
            <option key={m.valor} value={m.valor}>{m.nombre}</option>
          ))}
        </select>
      </div>

      <div className="fpf-filtro">
        <label htmlFor="fpf-anio">Año</label>
        <select
          id="fpf-anio"
          aria-label="Filtrar por año"
          value={filtros.anio || ''}
          onChange={(e) => handleChange('anio', e.target.value ? parseInt(e.target.value) : '')}
          className="fpf-select"
        >
          <option value="">Todos</option>
          {ANIOS.map((a) => (
            <option key={a} value={a}>{a}</option>
          ))}
        </select>
      </div>

      <div className="fpf-filtro">
        <label htmlFor="fpf-entidad">Entidad de Facturación</label>
        <select
          id="fpf-entidad"
          aria-label="Filtrar por entidad de facturación"
          value={filtros.entidadFacturacion || ''}
          onChange={(e) => handleChange('entidadFacturacion', e.target.value)}
          className="fpf-select"
        >
          <option value="">Todas</option>
          {entidades.map((entidad) => (
            <option key={entidad} value={entidad}>{entidad}</option>
          ))}
        </select>
      </div>

      <div className="fpf-filtro">
        <label htmlFor="fpf-obra-social">Obra Social / Prepaga</label>
        <select
          id="fpf-obra-social"
          aria-label="Filtrar por obra social o prepaga"
          value={filtros.idObraSocial || ''}
          onChange={(e) => handleChange('idObraSocial', e.target.value)}
          className="fpf-select"
        >
          <option value="">Todas</option>
          {obrasSociales.map((os) => (
            <option key={os.id} value={os.id}>{os.nombre}</option>
          ))}
        </select>
      </div>

      <div className="fpf-filtro">
        <label htmlFor="fpf-estado">Estado de Pago</label>
        <select
          id="fpf-estado"
          aria-label="Filtrar por estado de pago"
          value={filtros.estadoPago || ''}
          onChange={(e) => handleChange('estadoPago', e.target.value)}
          className="fpf-select"
        >
          {ESTADOS_PAGO.map((ep) => (
            <option key={ep.valor} value={ep.valor}>{ep.label}</option>
          ))}
        </select>
      </div>

      <div className="fpf-filtro fpf-filtro-boton">
        <Button
          type="button"
          className="fpf-btn-buscar"
          onClick={onBuscar}
          aria-label="Buscar facturas con los filtros seleccionados"
        >
          Buscar
        </Button>
      </div>
    </div>
  );
};

export default FiltrosPagosFacturas;
